import { useParams } from 'react-router-dom'
import { LittleModalCreateEdit } from '../../../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../../../../baseComponents/ModalsLayouts/types'
import { FormRender } from '../../../../../../../../../../forms/FormRenderer/types'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { WCalEmployeeAgreementHoursModelType } from '@teinor/erp/types/company/WCalParent/WCal/WCalEmployeeAgreementHours'
import { permissionCheck } from '../../../../../../../../../../baseComponents/PermissionChecker/function'
import { valueOrDefaultValue } from '../../../../../../../../../../utils/globals/valueOrDefaultValue'
import { TwinDictionary } from '../../../../../../../../../../utils/globals/dictionary'
import { useCallback } from 'react'
import { BeforeSubmitHandler } from '../../../../../../../../../../forms/TwinForm/types'

type ModalCEEmployeeAgreementHoursProps = ModalEditComponentProps & {}

interface WCalEmployeeAgreementHoursModelTypeExtended extends WCalEmployeeAgreementHoursModelType {
    typeHours?: number
}

const ModalCEEmployeeAgreementHours: React.FC<ModalCEEmployeeAgreementHoursProps> = ({ userPermissions, ...rest }) => {
    const { t } = useTwinTranslation()
    const params = useParams<{ id: string }>()
    const EmployeeId = params.id
    const { handleBeforeSubmit } = useModalCEEmployeeAgreementHoursLogic()
    const dictTypeHours: TwinDictionary = {
        0: { name: t('companyOwesEmployeeHours', 'Horas que la empresa debe al empleado') },
        1: { name: t('employeeOwesCompanyHours', 'Horas que el empleado debe a la empresa') }
    }

    const fields: FormRender<WCalEmployeeAgreementHoursModelTypeExtended> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'year',
                    label: t('year', 'Año'),
                    component: 'InputWithLabelMarginIntegerStateFull',
                    required: true,
                },
                {
                    name: 'totalMins',
                    label: t('totalMins', 'Horas totales convenio'),
                    component: 'InputHour',
                    value: rest?.allRowData?.totalMins,
                    maxHours: Infinity,
                    className: 'input_hour_agreement_hour'
                },
                {
                    name: 'typeHours',
                    label: t('typeHours', 'Tipo de horas'),
                    component: 'CustomSelect',
                    items: dictTypeHours,
                    value: parseInt(rest?.allRowData?.restMins || '0') <= 0 ? 0 : 1
                },
                {
                    name: 'restMins',
                    label: t('restMins', 'Horas a deber'),
                    component: 'InputHour',
                    value: String(Math.abs(rest?.allRowData?.restMins || 0)),
                    maxHours: Infinity,
                    className: 'input_hour_agreement_hour'
                },
                {
                    name: 'EmployeeId',
                    component: 'InputHidden',
                    value: EmployeeId,
                },
                {
                    name: 'id',
                    component: 'InputHidden',
                    value: rest.allRowData?.id,
                },
            ]
        }
    ]
    if (rest.allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, rest.allRowData)
        return (<LittleModalCreateEdit fields={parsedFields} url='/api/app/workingCalendar/agreementHours/updateWCalEmployeeAgreementHours' translations={{ title: t('editAgreementHours', 'Editar horas convenio'), button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} className='notFlexAutoFormRender modal_employee_agreement_hour'{...rest} beforeSubmit={handleBeforeSubmit} />)
    }
    return (
        <LittleModalCreateEdit fields={fields} url={'/api/app/workingCalendar/agreementHours/createWCalEmployeeAgreementHours'} translations={{
            title: t('addAgreementHours', 'Añadir horas convenio'),
            button: t('add', 'Añadir')
        }} haveButtonPermissions={true} className='modal_employee_agreement_hour' {...rest} beforeSubmit={handleBeforeSubmit} />
    )
}

const useModalCEEmployeeAgreementHoursLogic = () => {
    const handleBeforeSubmit: BeforeSubmitHandler = useCallback((values: any) => {
        if (parseInt(values.typeHours) === 0) {
            values.restMins = values.restMins * -1
        }
        return true
    }, [])
    return { handleBeforeSubmit }
}


export default ModalCEEmployeeAgreementHours